import { render, staticRenderFns } from "./queue_details.vue?vue&type=template&id=3fad3920&"
import script from "./queue_details.vue?vue&type=script&lang=js&"
export * from "./queue_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports